const SOURCE_DIGEST = /^sha256:[a-f0-9]{64}$/;

export function optionalPhase12SourceDigest(
  value: string | undefined,
): string | null {
  if (value === undefined || value === "") return null;
  if (!SOURCE_DIGEST.test(value)) {
    throw new Error("phase12_source_digest_marker_invalid");
  }
  return value;
}
